import { large } from "@/utilities/media-queries";
import { options } from "@/global/slick-options";

const sliders = document.querySelectorAll( '[data-press-slider]' );

let sliderOptions = {
    ...options,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
            }
        }
    ],

};

sliders.forEach( ( slider ) => {

    let isSlicked = false;

    initSlider( '' );
    jQuery( slider ).on( 'reInit', initSlider );
    large.addEventListener( 'change', initSlider );

    function initSlider( e ) {
        if ( large.matches && isSlicked ) {
            setTimeout( () => {
                jQuery( slider ).slick( 'unslick' );
                isSlicked = false;
            }, 75 );
        } else if ( !large.matches && !isSlicked ) {
            jQuery( slider ).slick( sliderOptions );
            isSlicked = true;
        }
    }
} );
